import { t } from './src-utils-translations.js';

const isStudioPage = () => {
  const path = window.location.pathname;
  if (path.includes(t("studio"))) return true;
  if (path.includes("ubikstudio")) return true;
  return false;
};
const isHelpCenterHomepage = () => {
  const path = window.location.pathname;
  const url = window.location.href;
  if (path === t("helpCenterHomepage")) return true;
  if (url.includes("help-center-page.care-staging.vpsvc.com")) return true;
  return false;
};
const isOrderHelpPage = () => window.location.href.includes(t("order-help-v2"));

export { isHelpCenterHomepage, isOrderHelpPage, isStudioPage };
//# sourceMappingURL=src-utils-chat-page-utils.js.map
